export default __webpack_public_path__ + "static/media/pull-tab.29577ce3.svg";